import {Injectable} from '@angular/core';
import { select, Store } from '@ngrx/store';
import {RootState} from '@app/store/root-state';
import {fetchAllRiderEvents} from '@app/store/faxe/rider-event/rider-event.actions';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { Observable } from 'rxjs';
import { selectRiderEventByRaceGuid } from '@app/store/faxe/rider-event/rider-event.selectos';
import { RiderEvent } from '@app/rest-client/faxe/models/rider-event';

@Injectable({
  providedIn: 'root'
})
export class RiderEventFacadeService {

  constructor(
    private readonly store: Store<RootState>) {
  }

  fetchRiderEvent(raceGuid: string, requiredSliceState: SliceState,  issuer: string): void {
    this.store.dispatch(
      fetchAllRiderEvents(
        {raceGuid: raceGuid, requiredSliceState, issuerStack: [issuer]}));
  }

  selectRiderEventByRaceGuid(raceGuid: string, requiredSliceState: SliceState): Observable<RiderEvent[]> {
    return this.store.pipe(
      select(selectRiderEventByRaceGuid(raceGuid, requiredSliceState)));
  }

}
